import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpService } from '../../shared/services/http.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogConfirmComponent } from '../../dialog-confirm/dialog-confirm.component';

@Component({
  selector: 'app-build-versions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './build-versions.component.html',
  styleUrls: ['./build-versions.component.scss']
})
export class BuildVersionsComponent implements OnInit {
  @Input() contentId: string;
  @Output() close = new EventEmitter<void>();
  @Output() selectVersion = new EventEmitter<any>();
  @Output() viewDiff = new EventEmitter<number>();


  versions: any[] = [];
  isLoading: boolean = false;

  constructor(private http: HttpService, private modalService: NgbModal) { }

  ngOnInit() {
    if (this.contentId) {
      this.loadVersions();
    }
  }

  async loadVersions() {
    this.isLoading = true;
    try {
      const res: any = await this.http.postAsync('builder/getVersions', {
        contentId: this.contentId
      });
      // Assuming res.data or res is the array. Adjust generic response handling as needed.
      if (res && res.data) {
        this.versions = res.data;
      } else if (Array.isArray(res)) {
        this.versions = res;
      }
    } catch (e) {
      console.error('Error loading versions', e);
    } finally {
      this.isLoading = false;
    }
  }

  onSelect(version: any) {
    this.selectVersion.emit(version);
    this.onClose();
  }

  onViewDiff(version: number, event: MouseEvent) {
    event.stopPropagation();
    this.viewDiff.emit(version);
    this.onClose();
  }

  async publish(versionId: string, event: MouseEvent) {
    event.stopPropagation();
    try {
      const modalRef = this.modalService.open(DialogConfirmComponent, {
        windowClass: 'center-modal-window'
      });
      modalRef.componentInstance.message = 'Are you sure you want to publish this version?';

      const result = await modalRef.result;
      if (result) {
        const res: any = await this.http.postAsync('hcontent/publish', {
          id: versionId
        });
        if (res.success) {
          // Optionally reload versions to reflect status change if needed
          this.loadVersions();
        }
      }
    } catch (e) {
      console.log('Dismissed');
    }
  }

  onClose() {
    this.close.emit();
  }
}

